import { observer } from 'mobx-react-lite';
import React from 'react';
import { ShippingCountryState } from '../../../../utils/shipping';
import AloDropdown, { DropdownItem } from '../YogaUI/alo-ui/AloDropdown';
import { LanguageState, updateLanguageCode } from 'src/scripts/utils/country-language';
import { isSiteInEnglish } from 'src/scripts/utils/helpers';

const renderOption = (option: DropdownItem) => (
  <>
    <span style={{ marginLeft: '1rem' }} className="GlobalLinkNoTx">
      {option.text}
    </span>
  </>
);

let LanguageInformation = ({
  htmlProps = {},
}: {
  htmlProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}) => {
  const { className = '', ...rest } = htmlProps;

  const dropdownItems =
    ShippingCountryState?.country?.languages?.map(({ locale, endonymName }) => ({
      key: locale.toLowerCase(),
      text: endonymName,
    })) || [];

  const onDropdownChange = (key: string) => {
    updateLanguageCode(key);
  };

  const dropdownValue = {
    key: LanguageState.languageCode,
    text: dropdownItems?.filter((item) => item.key === LanguageState.languageCode)[0]?.text || '',
  };

  return (
    <div {...rest} className={`LanguageInformation language-dropdown ${className}`}>
      <h6 className="title h6">Language</h6>
      {dropdownItems?.length > 1 ? (
        <AloDropdown
          searchable
          inputReadOnly={!isSiteInEnglish()}
          dropdownItems={dropdownItems}
          onChange={({ key }) => onDropdownChange(key)}
          placeholder="Select Country"
          value={dropdownValue}
          disableTranslation={true}
          MUIAutocompleteProps={{
            disableClearable: true,
            // disablePortal is false by default but is important
            // because parent Modal touch pan is disabled to fix ios scrolling
            disablePortal: false,
            renderOption,
          }}
        />
      ) : (
        <div className="language-info">
          <div className="GlobalLinkNoTx">{dropdownValue.text}</div>
          <span className="alo-checkmark-in-circle-icon"></span>
        </div>
      )}
    </div>
  );
};
LanguageInformation = observer(LanguageInformation);
export { LanguageInformation };
